export const successStatus = [200, 201, 204];
export const isAuthenticated = "amplify-signin-with-hostedUI";
export const unauthStatus = [401];
export const signinByPassword = "Temppass@123";
export const adminOTPPath = "/admin/otp";
export const userOTPPath = "/otp";
export const assessmentAssessableRoles = ["admin", "user"];

export const endPoints = {
  assessmentReports: "assessments/report",
  organizations: "organization",
  users: "members",
  locations: "locations",
  departments: "departments",
  deleteusers: "members",
  assessmentReportsDownload: "download-reports",
  organizationsDownload: "download/organizations",
  memberLogin: "auth/signin",
  memberSignUp: "auth/signup",
  demoUserLogin: "/auth/signin-by-password",
  generateSubmissionId: "assessment/generate-submission-id",
  markerDetails: "assessment/markers-details",
  session: "auth/session",
  signup: "/auth/signup",
  assessmentResult: "assessment/result",
  confirmOTP: "/auth/confirm-otp",
  downloadReport: "assessment/download-report",
  editProfile: "user/profile",
  createTeam: "teams/create-team",
  myTeams: "teams/my-teams",
  notMemberTeams: "teams/member/not-in",
  exitTeam: "teams/exit-team",
  joinTeam: "teams/join",
  joinOrganization: "organization/join",
  defaultProfilePictures: "teams/default-profile-pictures",
  contactUs: "contact-us/",
};

export const adminPoints = {
  adminLogin: "platform-admin/signin",
  organizationDetail: "platform-admin/organizations",
  createOrg: "platform-admin/organization",
  sendMail: "admin/send-email",
  getSummary: "platform-admin/summary",
  resendEmail: "platform-admin/resend-email",
  organizationType: "platform-admin/organization-types",
  createLocation: "platform-admin/locations",
  createDepartments: "platform-admin/departments",
};

export const onePagerPoints = {
  isi: `assessment/isi/result`,
  anxiety: `assessment/gad7/result`,
};

export const assessmentIds = {
  vasanaType: "1",
  introExtro: "2",
  ptsd: "3", // stress
  isi: "4", // sleep
  phq: "5", // happiness
  proQOL: "6", // quality
  audit: "7", // alcohol
  mspss: "8", // social
  anxiety: "9",
  xray: "16",
  mrf: "17",
  physical: "18",
};

export const assessmentNames = {
  1: "vasana-assessment",
};

export const assessmentTypes = {
  vasanaType: "Options",
  introExtro: "Slider",
  isi: "Slider",
};
export const organization_admin = "organization_admin";
export const department_admin = "department_admin";
export const location_admin = "location_admin";
export const clinician = "clinician";
export const location_admin_name = [location_admin, clinician];
export const organization_admin_name = [organization_admin];
export const department_admin_name = [department_admin];
export const organization_location_admin = [
  ...location_admin_name,
  ...organization_admin_name,
];
export const all_admin = [
  ...location_admin_name,
  ...organization_admin_name,
  ...department_admin_name,
];

export const nameOfRole = {
  organization_admin: "Organization Admin",
  location_admin: "Location Admin",
  department_admin: "Department Admin",
  clinician: "Clinician",
};

export const RoleToId = {
  location_admin: 2,
  clinician: 4,
};
export const IdToRole = {
  2: location_admin,
  4: clinician,
};

export const org_type_for_teams = [2, 3];

// ID: 001 - Vasana Assessment
// ID: 002 - Introvert vs Extrovert Assessment
// ID: 003 - Stress Presence Assessment
// ID: 004 - Sleep Quality Assessment
// ID: 005 - Happiness Levels Assessment
// ID: 006 - Quality of Life Assessment
// ID: 007 - Alcohol Consumption Assessment
// ID: 008 - Social Support Assessment
// ID: 009 - Anxiety Severity Assessment
// ID: 010 - Workplace Culture Review
// ID: 011 - PAQ Fire
// ID: 012 - PAQ Police
// ID: 013 - Body Metabolism Check
// ID: 014 - Pain and Inflammation Check
// ID: 015 - Brain Chemistry
// ID: 016 - Chest X-Ray
// ID: 017 - Medical Recommendation Form
// ID: 018 - Physical Exam Results
// ID: 019 - Brain Function and Health
// ID: 020 - Weight Loss Questionnaire
// ID: 021 - Lifestyle Balance
// ID: 022 - Hormone Health Assessment (Male)
// ID: 023 - Hormone Health Assessment (Female)
